module.exports = __webpack_public_path__ + "img/posts.dfd7ab8f.svg";